import { AutomationRuleActionsDataEnum } from 'modules/automation-rules/actions/enums/action-enum'

export const getShouldFetchActions = () =>
  Object.values(AutomationRuleActionsDataEnum).reduce((obj, el) => {
    return { ...obj, [el]: false }
  }, {} as Record<AutomationRuleActionsDataEnum, boolean>)
